// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const WebSocketMessageBody = {
    inlinedBody: (value) => {
        return Object.assign(Object.assign({}, value), { type: "inlinedBody", _visit: function (visitor) {
                return FernIr.WebSocketMessageBody._visit(this, visitor);
            } });
    },
    reference: (value) => {
        return Object.assign(Object.assign({}, value), { type: "reference", _visit: function (visitor) {
                return FernIr.WebSocketMessageBody._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "inlinedBody":
                return visitor.inlinedBody(value);
            case "reference":
                return visitor.reference(value);
            default:
                return visitor._other(value);
        }
    },
};
